import { Route, Routes, Navigate } from 'react-router-dom';
import { ROUTES } from 'utils';
import { useAuth } from '../lib';
import { Login } from '../components/Login';
import { Register } from '../components/Register';
import { AuthLayout } from '../components/AuthLayout';

export const AuthRoutes = ({ isEnabled } : { isEnabled: boolean }) => {
  const { user } = useAuth();

  // [!isEnabled] prevents auth routes from being enabled when app and/or voting are closed.
  if (user || !isEnabled) {
    return <Navigate to="/" />
  }

  return (
    <Routes>
      <Route path="*" element={<AuthLayout />}>
        <Route
          path="login"
          element={<Login />}
        />
        <Route
          path="register"
          element={<Register />}
        />
      </Route>
    </Routes>
  );
};
